import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HelpBlock, Input } from 'rsuite';
import ConfirmationModal from '../../ConfirmationModal';

export const MAX_REASON_LENGTH = 1000;

function CancelReservationConfirmationModal({
  show,
  title,
  message,
  confirmButtonLabel,
  onCancel,
  onConfirm,
  isSaving
}) {
  const [reason, setReason] = useState('');

  useEffect(
    () => {
      if (show) setReason('');
    },
    [show]
  );

  const trimmedReason = reason.trim();
  const isTooLong = trimmedReason.length > MAX_REASON_LENGTH;

  return (
    <ConfirmationModal
      show={show}
      title={title}
      onCancel={onCancel}
      onConfirm={() => onConfirm(trimmedReason)}
      cancelButtonLabel="No, keep reservation"
      confirmButtonLabel={isSaving ? 'Canceling...' : confirmButtonLabel}
      cancelButtonProps={{ disabled: isSaving }}
      confirmButtonProps={{
        disabled: !trimmedReason || isTooLong || isSaving,
        loading: isSaving
      }}
    >
      <p style={{ marginBottom: 10 }}>{message}</p>
      <Input
        componentClass="textarea"
        rows={4}
        name="cancellationReason"
        value={reason}
        onChange={setReason}
        disabled={isSaving}
        placeholder="Provide a reason for canceling this reservation"
      />
      <HelpBlock style={{ padding: 6 }} className={isTooLong ? 'error' : ''}>
        {isTooLong
          ? `Cancellation reason must not exceed ${MAX_REASON_LENGTH} characters.`
          : 'Required. This reason is saved as a note and may be emailed to the agency if email notifications are enabled.'}
      </HelpBlock>
    </ConfirmationModal>
  );
}

CancelReservationConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSaving: PropTypes.bool
};

CancelReservationConfirmationModal.defaultProps = {
  title: 'Cancel Reservation',
  message: 'Are you sure you want to cancel this reservation?',
  confirmButtonLabel: 'Yes, cancel reservation',
  isSaving: false
};

export default CancelReservationConfirmationModal;
